import React from "react";
import * as Styled from "./slider.styled";
import Slider from "rc-slider";
import { Box, Typography } from "@mui/material";
import { TextField } from "../MuiTextField";
import "rc-slider/assets/index.css";
function CustomSlider({
  title,
  value,
  onChange,
  symbol = "%",
  filledColor = "#81459B",
  thumbColor = "#81459B",
  bgColor = "#CCA3CF",
  min = 0,
  max = 100,
}) {
  const handleSliderValueChange = (newValue) => {
    if (typeof newValue === "number" && newValue >= min && newValue <= max) {
      onChange(newValue);
    }
  };

  const handleFieldValueChange = (e) => {
    const { value } = e.target;
    if (value.trim() === "") {
      onChange("");
      return;
    }

    if (value >= min && value <= max) {
      onChange(Number(value));
    }
  };

  return (
    <div>
      {" "}
      <Box>
        <Styled.Container>
          {title && (
            <Styled.RowDiv>
              <Typography
                sx={{
                  fontWeight: "400",
                  fontSize: "14px",
                  fontFamily: "DM Sans",
                }}
              >
                {title}
              </Typography>
            </Styled.RowDiv>
          )}

          <Styled.RowDiv style={{ marginLeft: 10 }}>
            <Slider
              min={min}
              max={max}
              value={value}
              onChange={handleSliderValueChange}
              trackStyle={{ backgroundColor: filledColor, height: 8 }}
              handleStyle={{
                borderColor: thumbColor,
                height: 20,
                width: 20,
                marginTop: -6,
                backgroundColor: thumbColor,
                opacity: 1,
              }}
              railStyle={{ backgroundColor: bgColor, height: 8 }}
            />

            <Styled.RowDiv>
              <TextField
                type="number"
                value={value >= min && value <= max ? value : min}
                disableUnderline
                placeholder=""
                onChange={handleFieldValueChange}
                min={min}
                max={max}
                fieldStyling={{
                  "& .MuiInputBase-root": {
                    border: "1px solid #bbbbbb",
                    outline: "none",
                    backgroundColor: "#ffffff",
                    fontFamily: "DM Sans",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#565556",
                    width: "45px",
                    height: "40px",
                    borderRadius: "5px",
                    marginLeft: "30px",
                    "&:focus": {
                      border: "none",
                      outline: "none",
                    },
                    "&::before, &::after": {
                      display: "none",
                    },
                  },
                }}
              />
              <Styled.PxText>{symbol}</Styled.PxText>
            </Styled.RowDiv>
          </Styled.RowDiv>
        </Styled.Container>
      </Box>
    </div>
  );
}

export default CustomSlider;
